@if (columns && appointmentsText) {
  <div class="container-appointments">
    <div nz-row>
      <nz-col [nzSpan]="24">
        <app-appointments-table
          [isFrom]="'home-page'"
          [appointmentText]="appointmentsText"
          [columns]="columns"
          [searchEnabled]="true"
          [innerFiltersEnabled]="true"
          [appointments]="appointments"
          [innerSelectData]="innerSelectData"
        ></app-appointments-table>
      </nz-col>
    </div>
  </div>
}
